import { api } from "libs/Axios";

export const checkOmbudsmanProtocol = async (body) => {
  try {
    return await api.post("/servico/v1/ouvidoria/validar", {
      protocolo: body?.protocolo,
      produto: body?.produto,
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const sendOmbudsmanProtocol = async (body, recaptcha) => {
  try {
    return await api.post(
      "/servico/v1/ouvidoria/enviar",
      {
        protocolo: {
          produto: body.protocolo.produto,
          numero: body.protocolo.numero,
        },
        solicitante: {
          nome: body.solicitante.nome,
          email: body.solicitante.email,
          tipoRetorno: body.solicitante.tipoRetorno,
          cpfCnpj: {
            numero: body.solicitante.cpfCnpj.numero,
            tipo: body.solicitante.cpfCnpj.tipo,
          },
          telefone: {
            ddd: body.solicitante.telefone.ddd,
            numero: body.solicitante.telefone.numero,
          },
        },
        comentario: body.comentario,
        anexos: body.anexos,
      },
      {
        headers: {
          "g-captcha-response": recaptcha,
        },
      }
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};
